import PersonCircleFill from './PersonCircleFill';

export default PersonCircleFill;
